<template><span class="num inline-flex rounded-[var(--radius-label)] bg-info/15 px-1 py-0.5 text-[length:var(--type-badge)] font-semibold text-info" title="Design preview; not connected">TODO</span></template>
